import {
    LabelContainer,
    Label,
    RequiredToShowToPartnerSignifier,
    ValidationsList,
    FormFieldContainer,
    TextAreaControlShowingEdits,
    Button
} from '../../../components/Form/FormStyles';
import {EditedProject} from '../EditedProject';
import {ValidateControl} from '../../../components/Controls/ValidateControl';
import {useState} from 'react';
import {replaceNewLinesToSpaces} from '../../../record-editing';

export function ImpactStoryCompletedShortControl({
    project,
    setProjectAndValidate,
    hideValidateControl,
    disabled,
    generateShortImpactStory
}: {
    project: EditedProject;
    setProjectAndValidate: (project: EditedProject) => void;
    hideValidateControl?: boolean;
    disabled?: boolean;
    generateShortImpactStory: (originalText: string) => Promise<string>;
}) {
    const [isGenerating, setIsGenerating] = useState(false);

    return (
        <FormFieldContainer>
            <LabelContainer>
                {!hideValidateControl && !disabled && (
                    <ValidateControl
                        validated={project.ImpactStoryCompletedShortValidated.current}
                        disabled={project.ImpactStoryCompletedShort.notValidToShowPartner}
                        onChange={(e) =>
                            setProjectAndValidate({
                                ...project,
                                ImpactStoryCompletedShortValidated:
                                    project.ImpactStoryCompletedShortValidated.update(e.validated)
                            })
                        }
                    />
                )}
                <Label htmlFor="impactStoryCompletedShort">
                    Impact story - completed (for PDF)
                </Label>
                <Button
                    disabled={disabled || isGenerating}
                    onClick={async () => {
                        setIsGenerating(true);
                        try {
                            const newText = await generateShortImpactStory(
                                project.ImpactStoryCompleted.current
                            );
                            setProjectAndValidate({
                                ...project,
                                ImpactStoryCompletedShort: project.ImpactStoryCompletedShort.update(
                                    replaceNewLinesToSpaces(newText)
                                )
                            });
                        } finally {
                            setIsGenerating(false);
                        }
                    }}>
                    {isGenerating ? 'Generating...' : 'Generate with AI'}
                </Button>
            </LabelContainer>
            <TextAreaControlShowingEdits
                id="impactStoryCompletedShort"
                disabled={disabled}
                rows={4}
                value={project.ImpactStoryCompletedShort}
                onChange={(e) =>
                    setProjectAndValidate({
                        ...project,
                        ImpactStoryCompletedShort: project.ImpactStoryCompletedShort.update(
                            replaceNewLinesToSpaces(e.target.value)
                        )
                    })
                }></TextAreaControlShowingEdits>
            <ValidationsList validations={project.ImpactStoryCompletedShort.validations} />
        </FormFieldContainer>
    );
}
